<template>
  <div id="app">
    <b-form v-on:submit.prevent="onSubmit">

      <b-form-group label="PVC Strip Width">
        <b-form-select v-model="form.strip"
                       v-on:change="onChangeStrip"
                       v-bind:options="strips"
                       required />
      </b-form-group>

      <b-form-group label="Strip Overlap">
        <b-form-select v-model="form.overlap"
                       v-bind:disabled="!form.strip"
                       v-on:change="onChangeOverlap"
                       v-bind:options="overlaps"
                       required />
      </b-form-group>

      <b-form-group label="Door Width">
        <b-form-select v-model="form.door"
                       v-bind:disabled="!form.overlap"
                       v-bind:options="doors"
                       required />
      </b-form-group>

      <b-form-group label="Number of Doors Requiring Strips">
        <b-form-select v-model="form.number"
                       v-bind:disabled="!form.door"
                       v-bind:options="numbers"
                       required />
      </b-form-group>

      <b-form-group>
        <b-button type="submit" size="sm" variant="primary">Calculator</b-button>
      </b-form-group>

      <b-form-group>
        <p class="result" v-if="result">Number of PVC Strips Needed: <span>{{ result }}</span></p>
      </b-form-group>

    </b-form>
  </div>
</template>

<script>
export default {
  name: 'App',
  data: () => ({
    form: {
      strip: '',
      overlap: '',
      door: '',
      number: ''
    },
    result: '',
    overlaps: [],
    doors: [],
    numbers: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    strips: [
    	{
    		text: '4"',
        value: 4,
        values: [
          {
            text: '100%',
            value: 100,
            values: [
              {
                text: "2'",
                value: 11
              },
              {
                text: "3'",
                value: 17
              },
              {
                text: "4'",
                value: 23
              },
              {
                text: "5'",
                value: 29
              },
              {
                text: "6'",
                value: 35
              },
              {
                text: "7'",
                value: 41
              },
              {
                text: "8'",
                value: 47
              },
              {
                text: "9'",
                value: 53
              },
              {
                text: "10'",
                value: 59
              },
              {
                text: "11'",
                value: 65
              },
              {
                text: "12'",
                value: 71
              },
              {
                text: "13'",
                value: 77
              },
              {
                text: "14'",
                value: 83
              },
              {
                text: "15'",
                value: 89
              },
              {
                text: "16'",
                value: 95
              },
              {
                text: "17'",
                value: 101
              },
              {
                text: "18'",
                value: 107
              },
              {
                text: "19'",
                value: 113
              },
              {
                text: "20'",
                value: 119
              },
            ]
          }
        ]
    	},
    	{
        text: '6"',
    		value: 6,
        values: [
          {
            text: "67%",
            value: 67,
            values: [
              {
                text: "2'",
                value: 6
              },
              {
                text: "3'",
                value: 9
              },
              {
                text: "4'",
                value: 12
              },
              {
                text: "5'",
                value: 15
              },
              {
                text: "6'",
                value: 18
              },
              {
                text: "7'",
                value: 21
              },
              {
                text: "8'",
                value: 24
              },
              {
                text: "9'",
                value: 27
              },
              {
                text: "10'",
                value: 30
              },
              {
                text: "11'",
                value: 33
              },
              {
                text: "12'",
                value: 36
              },
              {
                text: "13'",
                value: 39
              },
              {
                text: "14'",
                value: 42
              },
              {
                text: "15'",
                value: 45
              },
              {
                text: "16'",
                value: 48
              },
              {
                text: "17'",
                value: 51
              },
              {
                text: "18'",
                value: 54
              },
              {
                text: "19'",
                value: 57
              },
              {
                text: "20'",
                value: 60
              },
            ]
          },
          {
            text: "100%",
            value: 100,
            values: [
              {
                text: "2'",
                value: 7
              },
              {
                text: "3'",
                value: 11
              },
              {
                text: "4'",
                value: 15
              },
              {
                text: "5'",
                value: 19
              },
              {
                text: "6'",
                value: 23
              },
              {
                text: "7'",
                value: 27
              },
              {
                text: "8'",
                value: 31
              },
              {
                text: "9'",
                value: 35
              },
              {
                text: "10'",
                value: 39
              },
              {
                text: "11'",
                value: 43
              },
              {
                text: "12'",
                value: 47
              },
              {
                text: "13'",
                value: 51
              },
              {
                text: "14'",
                value: 55
              },
              {
                text: "15'",
                value: 59
              },
              {
                text: "16'",
                value: 63
              },
              {
                text: "17'",
                value: 67
              },
              {
                text: "18'",
                value: 71
              },
              {
                text: "19'",
                value: 75
              },
              {
                text: "20'",
                value: 79
              },
            ]
          }
        ]
    	},
      {
        text: '8"',
        value: 8,
        values: [
          {
            text: '50%',
            value: 50,
            values: [
              {
                text: "2'",
                value: 4
              },
              {
                text: "3'",
                value: 6
              },
              {
                text: "4'",
                value: 8
              },
              {
                text: "5'",
                value: 10
              },
              {
                text: "6'",
                value: 12
              },
              {
                text: "7'",
                value: 14
              },
              {
                text: "8'",
                value: 16
              },
              {
                text: "9'",
                value: 18
              },
              {
                text: "10'",
                value: 20
              },
              {
                text: "11'",
                value: 22
              },
              {
                text: "12'",
                value: 24
              },
              {
                text: "13'",
                value: 26
              },
              {
                text: "14'",
                value: 28
              },
              {
                text: "15'",
                value: 30
              },
              {
                text: "16'",
                value: 32
              },
              {
                text: "17'",
                value: 34
              },
              {
                text: "18'",
                value: 36
              },
              {
                text: "19'",
                value: 38
              },
              {
                text: "20'",
                value: 40
              },
            ]
          },
          {
            text: '100%',
            value: 100,
            values: [
              {
                text: "2'",
                value: 5
              },
              {
                text: "3'",
                value: 8
              },
              {
                text: "4'",
                value: 11
              },
              {
                text: "5'",
                value: 14
              },
              {
                text: "6'",
                value: 17
              },
              {
                text: "7'",
                value: 20
              },
              {
                text: "8'",
                value: 23
              },
              {
                text: "9'",
                value: 26
              },
              {
                text: "10'",
                value: 29
              },
              {
                text: "11'",
                value: 32
              },
              {
                text: "12'",
                value: 35
              },
              {
                text: "13'",
                value: 38
              },
              {
                text: "14'",
                value: 41
              },
              {
                text: "15'",
                value: 44
              },
              {
                text: "16'",
                value: 47
              },
              {
                text: "17'",
                value: 50
              },
              {
                text: "18'",
                value: 53
              },
              {
                text: "19'",
                value: 56
              },
              {
                text: "20'",
                value: 59
              },
            ]
          }
        ]
      },
      {
        text: '12"',
        value: 12,
        values: [
          {
            text: '33%',
            value: 33,
            values: [
              {
                text: "2'",
                value: 3
              },
              {
                text: "3'",
                value: 4
              },
              {
                text: "4'",
                value: 5
              },
              {
                text: "5'",
                value: 6
              },
              {
                text: "6'",
                value: 7
              },
              {
                text: "7'",
                value: 9
              },
              {
                text: "8'",
                value: 10
              },
              {
                text: "9'",
                value: 11
              },
              {
                text: "10'",
                value: 12
              },
              {
                text: "11'",
                value: 13
              },
              {
                text: "12'",
                value: 15
              },
              {
                text: "13'",
                value: 16
              },
              {
                text: "14'",
                value: 17
              },
              {
                text: "15'",
                value: 18
              },
              {
                text: "16'",
                value: 19
              },
              {
                text: "17'",
                value: 21
              },
              {
                text: "18'",
                value: 22
              },
              {
                text: "19'",
                value: 23
              },
              {
                text: "20'",
                value: 24
              },
            ]
          },
          {
            text: '67%',
            value: 67,
            values: [
              {
                text: "2'",
                value: 3
              },
              {
                text: "3'",
                value: 4
              },
              {
                text: "4'",
                value: 6
              },
              {
                text: "5'",
                value: 7
              },
              {
                text: "6'",
                value: 9
              },
              {
                text: "7'",
                value: 10
              },
              {
                text: "8'",
                value: 12
              },
              {
                text: "9'",
                value: 13
              },
              {
                text: "10'",
                value: 15
              },
              {
                text: "11'",
                value: 16
              },
              {
                text: "12'",
                value: 18
              },
              {
                text: "13'",
                value: 19
              },
              {
                text: "14'",
                value: 21
              },
              {
                text: "15'",
                value: 22
              },
              {
                text: "16'",
                value: 24
              },
              {
                text: "17'",
                value: 25
              },
              {
                text: "18'",
                value: 27
              },
              {
                text: "19'",
                value: 28
              },
              {
                text: "20'",
                value: 30
              },
            ]
          },
          {
            text: '100%',
            value: 100,
            values: [
              {
                text: "2'",
                value: 3
              },
              {
                text: "3'",
                value: 5
              },
              {
                text: "4'",
                value: 7
              },
              {
                text: "5'",
                value: 9
              },
              {
                text: "6'",
                value: 11
              },
              {
                text: "7'",
                value: 13
              },
              {
                text: "8'",
                value: 15
              },
              {
                text: "9'",
                value: 17
              },
              {
                text: "10'",
                value: 19
              },
              {
                text: "11'",
                value: 21
              },
              {
                text: "12'",
                value: 23
              },
              {
                text: "13'",
                value: 25
              },
              {
                text: "14'",
                value: 27
              },
              {
                text: "15'",
                value: 29
              },
              {
                text: "16'",
                value: 31
              },
              {
                text: "17'",
                value: 33
              },
              {
                text: "18'",
                value: 35
              },
              {
                text: "19'",
                value: 37
              },
              {
                text: "20'",
                value: 39
              },
            ]
          }
        ]
      },
      {
        text: '16"',
        value: 16,
        values: [
          {
            text: '25%',
            value: 25,
            values: [
              {
                text: "2'",
                value: 2
              },
              {
                text: "3'",
                value: 3
              },
              {
                text: "4'",
                value: 4
              },
              {
                text: "5'",
                value: 5
              },
              {
                text: "6'",
                value: 5
              },
              {
                text: "7'",
                value: 6
              },
              {
                text: "8'",
                value: 7
              },
              {
                text: "9'",
                value: 8
              },
              {
                text: "10'",
                value: 9
              },
              {
                text: "11'",
                value: 10
              },
              {
                text: "12'",
                value: 11
              },
              {
                text: "13'",
                value: 11
              },
              {
                text: "14'",
                value: 12
              },
              {
                text: "15'",
                value: 13
              },
              {
                text: "16'",
                value: 14
              },
              {
                text: "17'",
                value: 15
              },
              {
                text: "18'",
                value: 16
              },
              {
                text: "19'",
                value: 17
              },
              {
                text: "20'",
                value: 17
              },
            ]
          },
          {
            text: '50%',
            value: 50,
            values: [
              {
                text: "2'",
                value: 2
              },
              {
                text: "3'",
                value: 3
              },
              {
                text: "4'",
                value: 4
              },
              {
                text: "5'",
                value: 5
              },
              {
                text: "6'",
                value: 6
              },
              {
                text: "7'",
                value: 7
              },
              {
                text: "8'",
                value: 8
              },
              {
                text: "9'",
                value: 9
              },
              {
                text: "10'",
                value: 10
              },
              {
                text: "11'",
                value: 11
              },
              {
                text: "12'",
                value: 12
              },
              {
                text: "13'",
                value: 13
              },
              {
                text: "14'",
                value: 14
              },
              {
                text: "15'",
                value: 15
              },
              {
                text: "16'",
                value: 16
              },
              {
                text: "17'",
                value: 17
              },
              {
                text: "18'",
                value: 18
              },
              {
                text: "19'",
                value: 19
              },
              {
                text: "20'",
                value: 20
              },
            ]
          },
          {
            text: '75%',
            value: 75,
            values: [
              {
                text: "2'",
                value: 2
              },
              {
                text: "3'",
                value: 3
              },
              {
                text: "4'",
                value: 5
              },
              {
                text: "5'",
                value: 6
              },
              {
                text: "6'",
                value: 7
              },
              {
                text: "7'",
                value: 8
              },
              {
                text: "8'",
                value: 9
              },
              {
                text: "9'",
                value: 11
              },
              {
                text: "10'",
                value: 12
              },
              {
                text: "11'",
                value: 13
              },
              {
                text: "12'",
                value: 14
              },
              {
                text: "13'",
                value: 15
              },
              {
                text: "14'",
                value: 17
              },
              {
                text: "15'",
                value: 18
              },
              {
                text: "16'",
                value: 19
              },
              {
                text: "17'",
                value: 20
              },
              {
                text: "18'",
                value: 21
              },
              {
                text: "19'",
                value: 23
              },
              {
                text: "20'",
                value: 24
              },
            ]
          },
          {
            text: '100%',
            value: 100,
            values: [
              {
                text: "2'",
                value: 2
              },
              {
                text: "3'",
                value: 4
              },
              {
                text: "4'",
                value: 5
              },
              {
                text: "5'",
                value: 7
              },
              {
                text: "6'",
                value: 8
              },
              {
                text: "7'",
                value: 10
              },
              {
                text: "8'",
                value: 11
              },
              {
                text: "9'",
                value: 13
              },
              {
                text: "10'",
                value: 14
              },
              {
                text: "11'",
                value: 16
              },
              {
                text: "12'",
                value: 17
              },
              {
                text: "13'",
                value: 19
              },
              {
                text: "14'",
                value: 20
              },
              {
                text: "15'",
                value: 22
              },
              {
                text: "16'",
                value: 23
              },
              {
                text: "17'",
                value: 25
              },
              {
                text: "18'",
                value: 26
              },
              {
                text: "19'",
                value: 28
              },
              {
                text: "20'",
                value: 29
              }
            ]
          }
        ]
      }
    ]
  }),
  methods: {
    onSubmit: function () {
      this.result = this.form.door * this.form.number
    },
    onChangeStrip: function () {
      this.form.overlap = ''
      this.overlaps = this.strips.filter((item) => item.value === this.form.strip)[0].values
    },
    onChangeOverlap: function () {
      this.form.door = ''
      this.doors = this.overlaps.filter((item) => item.value === this.form.overlap)[0].values
    }
  }
}
</script>

<style>
#app {
  margin: 20px;
}
</style>
